'use client';
import * as React from 'react';

var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgCheckmarkBadge = function SvgCheckmarkBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.482 19.741c.295-.039.593.041.828.222l1.083.831a.995.995 0 0 0 1.213 0l1.124-.863a1 1 0 0 1 .737-.197l1.406.185a1 1 0 0 0 1.051-.607l.541-1.308a1 1 0 0 1 .54-.54l1.308-.54a.996.996 0 0 0 .607-1.052l-.178-1.355a1.12 1.12 0 0 1 .222-.828l.831-1.083a.995.995 0 0 0 0-1.213l-.863-1.124a1 1 0 0 1-.197-.737l.185-1.406a1 1 0 0 0-.607-1.05l-1.308-.542a1 1 0 0 1-.54-.54l-.54-1.308a.996.996 0 0 0-1.052-.607l-1.406.185a1 1 0 0 1-.736-.195l-1.124-.863a.995.995 0 0 0-1.213 0l-1.124.863c-.21.16-.475.231-.737.197l-1.406-.185a1 1 0 0 0-1.05.607l-.54 1.308a1 1 0 0 1-.54.54l-1.309.54a1 1 0 0 0-.607 1.051l.185 1.406a1 1 0 0 1-.197.736l-.863 1.124a.995.995 0 0 0 0 1.213l.863 1.124c.161.21.232.475.197.737l-.185 1.406a1 1 0 0 0 .607 1.051l1.308.541a1 1 0 0 1 .54.54l.541 1.308a.996.996 0 0 0 1.051.607z",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m14.797 10.603-3.501 3.501-2.1-2.1",
    vectorEffect: "non-scaling-stroke"
  })));
};

export { SvgCheckmarkBadge as default };
//# sourceMappingURL=checkmark-badge.svg.js.map
